import http from 'axios'
import PasteAction from '../../paste-action'

const state = {
  selectedUser: undefined,  // selected username (string)
  tree: undefined,          // the tree (object) of the selected user
  subtree: undefined,       // the displayed tree (equals "tree" if no subtree filter is set)
  loading: false,           // true while tree is loading (spinner is displayed)
  filter: {
    searchterm: '',         // text filter (string) or empty string for no filtering
    context: false          // if true the context filter is active
  },
  matchingNodeIds: []       // the array of nodes id where tabIndex will be set
}

const getters = {
  // An array of node IDs. If context filter is not selected returns an empty array
  contextNodeIds: (state, getters, rootState) => {
    return state.filter.context && buildContextNodeIds(rootState.infobitId, state.subtree) || []
  }
}

const actions = {

  loadTree ({state, dispatch}) {
    const username = state.selectedUser
    console.log('loadTree', username)
    resetTree(state)
    state.loading = true
    http.get('/infobits/tree/infobits.tree.' + username).then(response => {
      state.tree = response.data
      state.subtree = state.tree
      state.loading = false
      dispatch('resetTreeSearchtermFilter')
    })
  },

  setCollapsed ({rootState}, {node, collapsed}) {
    // Do nothing if proposed state is current state already.
    // Note: expanding an already expanded node would have the unwanted side effect of collapsing its direct childs.
    if (node.collapsed === collapsed) {
      return
    }
    node.collapsed = collapsed
    // collapse direct childs on expand
    if (!collapsed) {
      node.nodes.forEach(node => {
        node.collapsed = true
      })
    }
    //
    if (rootState.user) {
      http.put('/infobits/tree/node/' + node.id + '/collapsed/' + collapsed)
    }
  },

  setSubtreeFilter ({state}, node) {
    state.subtree = node
  },

  resetSubtreeFilter ({state}) {
    state.subtree = state.tree
  },

  setContextFilter ({state}, contextFilter) {
    state.filter.context = contextFilter
  },

  setSelectedUser ({state}, user) {
    state.selectedUser = user
  },

  insertInfobitInTree ({dispatch}, {infobitId, parentNode, predNodeId}) {
    http.put('/infobits/tree/infobit/' + infobitId + '/parent/' + parentNode.id + '/pred/' + predNodeId)
    dispatch('expandAndSelect', {node: parentNode, infobitId})
  },

  removeNode ({dispatch}, node) {
    console.log('Removing node', node.id)
    http.delete('/infobits/tree/node/' + node.parentAssocId)
    dispatch('deselectInfobitIfSelected', node.infobit.id)
  },

  moveSubtree ({dispatch}, {rootNode, parentNode, predNodeId}) {
    console.log('Moving subtree', rootNode.id)
    http.put('/infobits/tree/node/' + rootNode.parentAssocId + '/parent/' + parentNode.id + '/pred/' + predNodeId)
    dispatch('expandAndSelect', {node: parentNode, infobitId: rootNode.infobit.id})
  },

  copySubtree ({dispatch}, {rootNode, parentNode, predNodeId}) {
    http.post('/infobits/tree/node/' + rootNode.id + '/parent/' + parentNode.id + '/pred/' + predNodeId)
    dispatch('expandAndSelect', {node: parentNode, infobitId: rootNode.infobit.id})
  },

  createTransclusion ({dispatch}, {rootNode, parentNode, predNodeId}) {
    http.put('/infobits/tree/node/' + rootNode.id + '/parent/' + parentNode.id + '/pred/' + predNodeId + '/transclude')
    dispatch('expandAndSelect', {node: parentNode, infobitId: rootNode.infobit.id})
  },

  /**
   * @param   node   where the user clicked paste
   */
  pasteSubtree ({state, rootState, dispatch}, node) {
    switch (rootState.clipboard.action) {
      case PasteAction.INSERT:
        console.log('insertInfobitInTree(node)', node)
        dispatch('insertInfobitInTree', {infobitId: rootState.clipboard.content.id, parentNode: node, predNodeId: -1})
        break
      case PasteAction.MOVE:
        console.log('moveSubtree(node)', node)
        dispatch('moveSubtree', {rootNode: rootState.clipboard.content, parentNode: node, predNodeId: -1})
        break
      case PasteAction.COPY:
        console.log('copySubtree(node)', node)
        dispatch('copySubtree', {rootNode: rootState.clipboard.content, parentNode: node, predNodeId: -1})
        break
      case PasteAction.TRANSCLUDE:
        console.log('createTransclusion(node)', node)
        dispatch('createTransclusion', {rootNode: rootState.clipboard.content, parentNode: node, predNodeId: -1})
        break
      default:
        throw new Error('Unexpected paste action')
    }
  },

  searchTree ({state, dispatch}) {
    if (state.filter.searchterm) {
      dispatch('resetMatchingNodeIds')
      searchTree(state.tree)
      console.log('tabIndex', state.matchingNodeIds, state.matchingNodeIds.length)
    }
  },

  resetMatchingNodeIds () {
    state.matchingNodeIds = []
  },

  resetTreeSearchtermFilter ({state}) {
    state.filter.searchterm = ''
  },

  setSortMode ({rootState}, {node, sortMode}) {
    console.log('setSortMode', node.id, sortMode)
    node.sort = sortMode
    if (rootState.user) {
      http.put('/infobits/tree/node/' + node.id + '/sort/' + sortMode)
    }
  },

  /**
   * Expands the given node and selects the given infobit.
   *
   * @param   params    an object with these properties:
   *                      "node" - the node to expand
   *                      "infobitId" - the infobit to select
   */
  expandAndSelect ({dispatch}, {node, infobitId}) {
    dispatch('setCollapsed', {
      node,
      collapsed: false
    })
    dispatch('selectInfobit', infobitId)
  },

  retypeInfobit ({state}, {infobitId, infobitType}) {
    console.log('Retyping infobit', infobitType)
    http.put('/infobits/infobit/' + infobitId + '/type/' + infobitType)
  },

  // WebSocket messages

  _insertInfobitInTree (_, {node, parentNodeId, predNodeId}) {
    insertNodes(node, parentNodeId, predNodeId)
  },

  _removeNode (_, {nodeId}) {
    removeNodes(nodeId)
  },

  _moveSubtree (_, {parentAssocId, parentNodeId, predNodeId, newParentAssocId}) {
    findNodeByAssocId(parentAssocId, (nodes, i) => {
      var node = removeNode(nodes, i)               // remove from source
      node.parentAssocId = newParentAssocId
      insertNodes(node, parentNodeId, predNodeId)   // insert at target
    })
  },

  _copySubtree (_, {tree, parentNodeId, predNodeId}) {
    insertNodes(tree, parentNodeId, predNodeId)
  },

  _createTransclusion (_, {tree, parentNodeId, predNodeId}) {
    insertNodes(tree, parentNodeId, predNodeId)
  },

  _updateInfobit (_, {infobit}) {
    findInfobitInTree(infobit.id, i => {
      i.title = infobit.title
    })
  },

  _retypeInfobit (_, {infobitId, type}) {
    findInfobitInTree(infobitId, i => {
      i.type = type
    })
  }
}

export default {
  state,
  getters,
  actions
}

// === State Helper ===

// TODO: unify all tree traversal functions

function resetTree (state) {
  state.tree = {nodes: []}
  state.subtree = state.tree
}

/**
 * Recursivey searches a subtree for the search term.
 * 1) Stores the IDs of matching nodes in the global array matchingNodeIds.
 * 2) Expands all nodes which have matches in their subtrees.
 *
 * @param   node    the subtree to search
 *
 * @return  true if any of the node's subtrees, or the node itself, matches the search term.
 */
function searchTree (node) {
  // 1) check node match
  var nodeMatch = hasMatch(node)
  if (nodeMatch) {
    state.matchingNodeIds.push(node.id)
  }
  // 2) expansion
  var childMatch = false
  node.nodes.forEach(child => {
    if (searchTree(child)) {
      childMatch = true
    }
  })
  if (childMatch) {
    node.collapsed = false
  }
  //
  return nodeMatch || childMatch
}

function hasMatch (node) {
  if (!isRootNode(node.id)) {
    let terms = state.filter.searchterm.split(' ')
    for (var i = 0, term; (i < terms.length); i++) {
      term = terms[i]
      if (node.infobit.title.toLowerCase().indexOf(term.toLowerCase()) <= -1) {
        return false
      }
    }
    return true
  }
}

function buildContextNodeIds (infobitId, node) {
  var hasInfobitMatch
  var contextNodeIds = []
  pushContextNodeIds(infobitId, node)

  return contextNodeIds

  function pushContextNodeIds (infobitId, node) {
    var infobitMatch = false
    node.nodes.forEach(child => {
      // Check infobit match
      hasInfobitMatch = infobitIdMatch(infobitId, child)
      if (hasInfobitMatch) {
        infobitMatch = true
        contextNodeIds.push(child.id)
      }
    // push node IDs
      if (pushContextNodeIds(infobitId, child)) {
        infobitMatch = true
      }
      if (infobitMatch) {
        node.collapsed = false
        contextNodeIds.push(node.id)
      }
    })
    return infobitMatch || hasInfobitMatch
  }
}

function infobitIdMatch (infobitId, node) {
  return infobitId === node.infobit.id
}

function isRootNode (nodeId) {
  return nodeId === state.tree.id
}

function findInfobitInTree (id, callback) {
  findInfobitInNodes(state.tree.nodes)

  function findInfobitInNodes (nodes) {
    nodes.forEach(node => {
      if (node.infobit.id === id) {
        callback(node.infobit)
      }
      findInfobitInNodes(node.nodes)
    })
  }
}

function insertNodes (node, parentNodeId, predNodeId) {
  // ### FIXME: is cloning required when adding node to multiple places?
  if (predNodeId === -1) {
    if (isRootNode(parentNodeId)) {
      insertNode(node, state.tree, 0)   // insert at begin
    } else {
      findNodes(parentNodeId, (nodes, i) =>
        insertNode(node, nodes[i], 0)   // insert at begin
      )
    }
  } else {
    findNodes(predNodeId, (_, i, parent) =>
      insertNode(node, parent, i + 1)
    )
  }
}

// ### TODO: drop parent param
function insertNode (node, parent, i) {
  parent.nodes.splice(i, 0, node)
}

/**
 * From the entire tree removes all occurrences of a certain node.
 *
 * @param   nodeId        the node to remove
 * @param   parentNodeId  Optional: only remove node when it is child of this parent ### TODO: drop it? Not needed.
 */
function removeNodes (nodeId, parentNodeId) {
  findNodes(nodeId, (nodes, i, parent) => {
    if (!parentNodeId || parentNodeId === parent.id) {
      removeNode(nodes, i)
    }
  })
}

/**
 * Removes the node at index i from the given array.
 *
 * @returns   the removed node.
 */
function removeNode (nodes, i) {
  return nodes.splice(i, 1)[0]
}

/**
 * Searches the entire tree for the first occurrences of a certain node.
 * Returns the found position.
 * <p>
 * Can't be used to find the root node.
 *
 * @return  an object with 2 properties:
 *            "nodes" - the nodes array in which the node is found
 *            "i"     - the array index where the node is found
 *          If the node is not found <code>undefined</code> is returned
 */
/* function findNode (nodeId) {
  return findNodeInNodes(state.tree.nodes)

  function findNodeInNodes (nodes) {
    for (var i = 0, node; (node = nodes[i]); i++) {
      if (node.id === nodeId) {
        return {nodes, i}
      } else {
        var found = findNodeInNodes(node.nodes)
        if (found) {
          return found
        }
      }
    }
  }
} */

/**
 * Searches the entire tree for all occurrences of a certain node.
 * Calls back for every occurrence.
 * <p>
 * Can't be used to find the root node.
 *
 * @param   nodeId      the node ID to search
 * @param   callback    called for every occurrence. 3 arguments are passed:
 *                        "nodes"  - the nodes array in which the node is found
 *                        "i"      - the array index where the node is found
 *                        "parent" - the node the nodes array originates from
 */
function findNodes (nodeId, callback) {
  findNodeInNodes(state.tree.nodes, state.tree)

  function findNodeInNodes (nodes, parent) {
    nodes.forEach((node, i) => {
      if (node.id === nodeId) {
        callback(nodes, i, parent)
      }
      findNodeInNodes(node.nodes, node)
    })
  }
}

function findNodeByAssocId (assocId, callback) {
  return findInNodes(state.tree.nodes)

  function findInNodes (nodes) {
    for (var i = 0, node; (node = nodes[i]); i++) {
      if (node.parentAssocId === assocId) {
        callback(nodes, i)
        return true
      }
      if (findInNodes(node.nodes)) {
        return true
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/tree-panel.js